export default "__VITE_ASSET__C4z98WXM__"